import React from 'react';
import heroImg from '../../../assets/image copy 2.png';
import { FaCross } from 'react-icons/fa';

export default function Hero({ onSelectSection }) {
  const heroContent = {
    headingMain: "Growing in Faith,",
    headingSub: "United in Christ",
    quote: "I am with you always",
    ref: "Matthew 28:20",
    bgImg: heroImg
  };

  return (
    <section className="relative w-full px-0 mt-0 mb-0">
      {/* ── 100% Full-Width Hero Box Behind Navbar ── */}
      <div className="relative w-full overflow-hidden rounded-b-[36px] sm:rounded-b-[44px] md:rounded-b-[52px] min-h-[580px] sm:min-h-[640px] md:min-h-[700px] lg:min-h-[740px] pt-32 sm:pt-36 md:pt-40 pb-20 sm:pb-24 md:pb-32 shadow-[0_15px_50px_rgba(0,0,0,0.06)] bg-[#FAF7F2]">
        
        {/* Edge-to-Edge Full-Width Background Image (Cathedral & Sky) */}
        <div className="absolute inset-0 z-0 pointer-events-none">
          <img
            src={heroContent.bgImg}
            alt="CSI Diocese of Malabar Cathedral"
            className="w-full h-full object-cover object-center filter brightness-[1.02] contrast-[1.02]"
          />
        </div>

        {/* Soft subtle Gradient Overlay ONLY behind text for legibility */}
        <div className="absolute inset-y-0 left-0 z-[1] pointer-events-none bg-gradient-to-r from-[#FFFDF9]/95 via-[#FFFDF9]/75 to-transparent w-full max-w-[720px]" />

        {/* Hero Left Content */}
        <div className="relative z-10 w-full h-full flex flex-col justify-center px-6 sm:px-12 lg:px-20 py-6 pb-20 md:pb-28 max-w-[760px] text-left">
          
          <h1 className="font-serif text-[38px] sm:text-[50px] md:text-[58px] lg:text-[66px] font-bold leading-[1.08] tracking-tight mb-3 text-[#1a1715]">
            {heroContent.headingMain}<br />
            <span className="text-[#842343]">{heroContent.headingSub}</span>
          </h1>

          {/* Elegant Gold Ornamental Divider */}
          <div className="flex items-center gap-2.5 my-3 text-[#c39b5b]">
            <div className="w-16 sm:w-24 h-[1.5px] bg-[#c39b5b]/60 rounded-full" />
            <svg className="w-4 h-4 text-[#c39b5b] flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" />
            </svg>
            <div className="w-16 sm:w-24 h-[1.5px] bg-[#c39b5b]/60 rounded-full" />
          </div>

          <p className="text-[#4A3F3B] text-[16px] sm:text-[18px] font-sans font-normal leading-[1.65] my-3 max-w-[500px]">
            We welcome you to our Diocese –<br className="hidden sm:inline" />
            a community of faith, hope and love.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-wrap items-center gap-4 mt-4">
            <button
              onClick={() => onSelectSection('about')}
              className="bg-[#842343] hover:bg-[#6c1b35] text-white font-sans font-semibold text-[15px] px-8 py-3.5 rounded-full shadow-[0_6px_22px_rgba(132,35,67,0.32)] hover:shadow-[0_8px_28px_rgba(132,35,67,0.42)] hover:-translate-y-0.5 transition-all duration-300 flex items-center gap-3 cursor-pointer group"
            >
              <span>Learn More</span>
              <span className="text-base transition-transform duration-300 group-hover:translate-x-1">→</span>
            </button>

            <button
              onClick={() => onSelectSection('live')}
              className="bg-white/95 hover:bg-white text-[#1e1a18] border border-[#c39b5b]/50 font-sans font-semibold text-[15px] px-7 py-3.5 rounded-full shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 flex items-center gap-3 cursor-pointer group"
            >
              <div className="w-6 h-6 rounded-full border border-[#c39b5b] text-[#c39b5b] flex items-center justify-center text-[9px] pl-[2px] group-hover:bg-[#c39b5b]/10 transition-colors">
                ▶
              </div>
              <span>Watch Video</span>
            </button>
          </div>
        </div>

        {/* ── Floating Scripture Box on Right Side ── */}
        <div className="hidden sm:block absolute bottom-20 right-8 sm:bottom-24 sm:right-10 md:bottom-28 md:right-14 z-10 bg-gradient-to-br from-white/95 via-[#FAF6F0]/95 to-[#F6EDE4]/95 backdrop-blur-md px-7 py-6 sm:px-8 sm:py-7 rounded-[26px] border border-white/90 shadow-[0_18px_40px_rgba(132,35,67,0.08)] max-w-[270px] sm:max-w-[300px] text-left group hover:scale-[1.02] transition-all duration-300">
          {/* Quote Mark */}
          <span className="font-serif font-bold text-[#c39b5b] text-5xl sm:text-6xl leading-none select-none block -mb-3 opacity-90">
            “
          </span>
          <p className="font-serif font-bold text-[#1a1715] text-[21px] sm:text-[24px] leading-[1.28] tracking-tight mb-2">
            {heroContent.quote}
          </p>
          <p className="text-[#8A7E79] text-xs sm:text-sm font-sans font-semibold">
            — {heroContent.ref}
          </p>

          {/* Decorative Gold Cross in Bottom Right */}
          <div className="absolute bottom-4 right-5 text-[#c39b5b]/40 group-hover:text-[#c39b5b]/70 transition-colors">
            <FaCross className="w-7 h-7 sm:w-8 sm:h-8" />
          </div>
        </div>

      </div>
    </section>
  );
}
